import moment from "moment-timezone";
import { ReactNode } from "react";
import ClassModel from "src/models/ClassModel";
import MembershipOfferingModel from "src/models/MembershipOfferingModel";
import OfferingModel from "src/models/OfferingModel";
import { useStore } from "src/stores/Store";
import getOfferingDates from "src/utils/getOfferingDates";
import tw from "src/utils/tw";
import { OfferingStatus } from "types/code-generator";

interface Props {
  offering: OfferingModel | ClassModel | MembershipOfferingModel;
  viewableOnly?: boolean;
  registrationOnly?: boolean;
}

interface PublishTagProps {
  not?: boolean;
  archived?: boolean;
  soon?: boolean;
  color?: string;
  children?: ReactNode;
  className?: string;
}

export const PublishTag = (props: PublishTagProps) => {
  let text = "text-success";

  if (props.soon) {
    text = "text-main";
  } else if (props.archived) {
    text = "text-empty";
  } else if (props.not) {
    text = "text-error";
  } else if (props.color) {
    text = `text-${props.color}`;
  }

  return (
    <div
      className={tw(
        text,
        "uppercase",
        "text-xs",
        "font-bold",
        "tracking-wide",
        props.className
      )}
    >
      {props.children}
    </div>
  );
};

export default function PublishTags(props: Props) {
  const store = useStore();

  let timezone;

  if (store.userTimezone !== store.organization.timezone) {
    const today = moment();
    timezone = today.tz(store.organization.timezone).format("z");
  }

  const {
    publishString,
    registrationString,
    published,
    publishedSoon,
    registrationOpen,
    registrationOpenSoon,
  } = getOfferingDates({
    offering: props.offering,
    timezone,
  });

  return (
    <div>
      {!props.registrationOnly && (
        <PublishTag
          key="viewable"
          not={!published}
          soon={publishedSoon && !published}
          archived={props.offering.status === OfferingStatus.Archived}
        >
          {publishString}
        </PublishTag>
      )}
      {!props.viewableOnly && (
        <PublishTag
          key="registration"
          not={!registrationOpen}
          soon={registrationOpenSoon}
        >
          {registrationString}
        </PublishTag>
      )}
    </div>
  );
}
